import Immutable from 'immutable';

import { COLLECTION_SHAPE } from '../../../config/shapes';

import {
  CLEAR_MANUAL_VOUCHER_PAYMENT,
  CLEAR_MANUAL_VOUCHER_PAYMENTS,
  CLEAR_MANUAL_VOUCHER_PAYMENT_RECONCILIATION,
  FLAG_GETTING_MANUAL_VOUCHER_PAYMENTS,
  FLAG_MANUAL_VOUCHER_PAYMENT_ACTIVITY,
  FLAG_MANUAL_VOUCHER_PAYMENT_RECONCILIATION,
  GET_MANUAL_VOUCHER_PAYMENT,
  GET_MANUAL_VOUCHER_PAYMENTS,
  GET_MANUAL_VOUCHER_PAYMENT_RECONCILIATION,
} from '../../../actions/types/corporate/ManualVoucherPayment';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),

  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),

  reconciliation: Immutable.Map({
    content: Immutable.Map(),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_MANUAL_VOUCHER_PAYMENTS:
      return state.setIn(['all', 'loading'], payload);

    case GET_MANUAL_VOUCHER_PAYMENTS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));

    case CLEAR_MANUAL_VOUCHER_PAYMENTS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );

    case FLAG_MANUAL_VOUCHER_PAYMENT_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );

    case GET_MANUAL_VOUCHER_PAYMENT:
      return state.setIn(['current', 'content'], Immutable.Map(payload));

    case CLEAR_MANUAL_VOUCHER_PAYMENT:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));

    case FLAG_MANUAL_VOUCHER_PAYMENT_RECONCILIATION:
      return state.setIn(['reconciliation', 'loading'], payload);

    case GET_MANUAL_VOUCHER_PAYMENT_RECONCILIATION:
      return state.setIn(['reconciliation', 'content'], Immutable.Map(payload));

    case CLEAR_MANUAL_VOUCHER_PAYMENT_RECONCILIATION:
      return state.setIn(
        ['reconciliation'],
        INITIAL_STATE.get('reconciliation'),
      );

    default:
      return state;
  }
};
